import React  from "react";
import { connect } from "react-redux";
import RecognitionWall from "./components/RecognitionWall";

const Recognitions = () => {
  return (
    <div className="space-y-6">
        <RecognitionWall />
    </div>
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Recognitions);